import { Box, Skeleton } from "@mui/material";

export const CardListSkeleton = () => (
  <Box my={2} width="100%">
    <Skeleton height={63} variant="rounded" />
  </Box>
);
